module.exports = __webpack_public_path__ + "static/media/back-home.79f4beae.wav";